<template>
    <main class="app-get-step" id="mainContent">
        <div class="app-main-content">
            <div class="insuranceShowError app-alert-error app-system-alert" v-if="insuranceShowErrorMessage">
                <p>To continue with your registration transaction you must have liability insurance and certify that you have read the Insurance statement.
                    Please review your response below.
                </p>
            </div>
            <h1>{{ screenData.title }}</h1>

            <div class="app-content-panels">
            <!-- left panel (form) -->
                <div class="app-panel-left">
                    <div>
                        <p>By checking "Yes" below, I hereby make application to register the described vehicle, and as part of my application declare that I am the owner 
                            or an authorized agent and certify under penalty of perjury that this vehicle is covered by liability insurance as described in  <a href="javascript: void(0)" @click="showModalActive=true" tabindex="0"><strong>RIGL 31-47 Motor Vehicles Reparations Act</strong></a>  
                            and will abide by conditions stated therein
                        </p>
                        <div class="app-input-group">
                            <div class="app-input-selector"><input type="radio" id="yes" name="notify" v-model="insuranceInfo" value="yes" @change="insuranceError=false; insuranceShowErrorMessage=false">
                                <label for="yes">Yes</label>  
                            </div>
                            <div class="app-input-selector"><input type="radio" id="no" name="notify-no" v-model="insuranceInfo" value="no" @change="insuranceError=false"> 
                                <label for="no">No</label> 
                            </div>
                        </div>
                    </div>     
                    <p class="app-error-message" v-if="insuranceError"> Response to this question is required. </p>
                    <p id="app-error-message" class="sr-only" v-if="insuranceError"> Response to this question is required. </p>
                    <BaseButtonGroup>
                        <!-- <button type="button" @click="handleRouting(true)">Previous</button>
                        <button type="button" class="app-btn-primary"
                            @click="handleRouting(false)">Next
                        </button>
                        <button type="button" v-if="!disableBtn" @click="getGoToProfile()">Cancel and go to profile</button>
                        <button type="button" :class="{ 'disabled': !disableBtn }" :aria-disabled="!disableBtn" @click="goToTxnCart(true)" v-if="disableBtn">
                            Cancel and go to cart
                        </button> -->

                        <CustomButton @click="handleRouting(true)" class="resend-code">Previous</CustomButton>
                        <CustomButton @click="handleRouting(false)">Next</CustomButton>
                        <CustomButton v-if="!disableBtn" @click="getGoToProfile()" class="resend-code">Cancel and go to profile</CustomButton>
                        <CustomButton :class="{ 'disabled': !disableBtn }" :aria-disabled="!disableBtn" @click="goToTxnCart(true)" v-if="disableBtn" class="resend-code">
                            Cancel and go to cart
                        </CustomButton>
                    </BaseButtonGroup>
                </div>
            </div>
        </div>
        <BaseModal modal-id="modalRules" :show-modal="showModalActive">
            <template #heading>
                <div>
                    <span>Read this insurance statement then follow the instructions for the transaction:</span>           
                </div>
            </template>
            <template #content>
                <div class="app-modal-basic">
                    <div>
                        <p> The undersigned (hereinafter referred to as "applicant") swears that, in compliance with Title 31, Chapter 47 of the General Laws, Motor and Other Vehicles, known as the Motor Vehicles Reparations Act, he/she will not operate or allow to be operated the motor vehicle described in this registration nor any other motor vehicle unless all such motor vehicles are covered for financial security.</p>

                        <p>Because of a concern over the rising toll of motor vehicle accidents and the suffering and loss thereby inflicted, the legislature determined that it is a matter of grave concern that motorists shall be financially able to respond in damages for their negligent acts so that innocent victims of motor vehicle accidents may be recompensated for the injury and financial loss inflicted upon them. The aforementioned act was passed to address such concern.</p>

                        <p>The act requires every natural person, firm, partnership, association or corporation registering a vehicle or renewing the registration of a vehicle to aver that he/she will provide financial security on same.</p>

                        <p>The obligation will be met by maintaining a policy of liability insurance with bodily injury limits of $25,000 to any one person and $50,000 to two or more persons in any one accident along with a limit of $25,000 for injury to or destruction of property of others in any one accident or a combined bodily injury and property damage liability limit of $75,000; 
                            OR by filing with the assistant director for motor vehicles in the Department of Transportation, a financial security bond in the amount of $75,000; OR by making a financial security deposit with the assistant director of motor vehicles in the Department of Transportation in the amount of $75,000; OR by qualifying as a self-insurer.</p>

                        <p>Penalties for failure to comply with the provisions of the act are a minimum fine of $500., maximum fine of $5,000, and revocation of motor vehicle registration and license plates for a period of three months for the first offense, six months for the second and one year for the third and subsequent offenses. In addition, violation of the law a third or subsequent time is deemed a misdemeanor and punishment may include a maximum fine of $5,000., a year imprisonment or both.</p>

                        <p>The existence of this act and its requirements does not prevent the possibility that the applicant may be involved in an accident with an owner or operator of a vehicle who is without financial responsibility.</p>
                    </div>
                </div>
            </template>
            <template #footing>
                <BaseButtonGroup> 
                    <template #default>
                        <button @click.prevent="getShowModalActive()">
                            Close
                        </button> 
                    </template>
                </BaseButtonGroup>
            </template>
        </BaseModal>
    </main>
</template>
    
<script>
import appConfig from '@/app.config';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import { mapState, mapActions } from 'vuex';
import BaseModal from '@/components/ui/BaseModal'; 
import * as COMMONS from '../../store/_commons';
import CustomButton from '../../components/CustomButton.vue';

export default {
    name: 'TransactionInformation',
    page: {
      title: `Transaction Information | ${appConfig.shortName}`,
      meta: [
        {
          name: 'description',
          content: 'You can renew your vehicle registrations'
        }
      ]
    },

    data() {
      return {
        stepNum: 2,
        screenData: {},
        enableNext: true,
        showError: false,
        showModalActive: false,
        insuranceInfo: '',
        insuranceShowErrorMessage: false,
        insuranceError: false,
      }
    },

    components: {
        BaseButtonGroup,
        BaseModal,
        CustomButton
    },

    computed: {
        ...mapState([
            'LANG',
            'STEPS',
        ]),
        language() {
            return this.LANG;
        },

        disableBtn() {
            let btn = false;
            if(this.$store.state.guestLogin.cartTransactions){
                btn = this.$store.state.guestLogin.cartTransactions.cartTransactions.length > 1
            }
            return btn;
        }
    },

    created() {
        this.screenData = this.STEPS[this.stepNum]; 

        document.body.setAttribute("tabindex", "1");
        document.body.focus();
        document.body.removeAttribute("tabindex");
    },

    methods: {
        ...mapActions({
            // getCreateTransactionService: COMMONS.GUEST_CREATETRANSACTION,
            // getRemoveTransaction: COMMONS.GUEST_REMOVETRANSACTION,
            // getAddTransaction: COMMONS.GUEST_ADDTRANSACTION,
            getRegistrationRenewalFee: COMMONS.GUEST_REGISTRATION_RENEWAL_FEE,
            getSaveWipData: COMMONS.GUEST_SAVEWIPDATA,
            getCancelTransaction: COMMONS.GUEST_CANCELTRANSACTION
        }),

        async handleRouting(isPrev = false) {
            if (isPrev) {
                // await this.getRemoveTransaction().then(()=> {
                await this.getCancelTransaction().then(()=> {
                    this.$emit('getStep' , 1);
                    this.$store.state.guestLogin.step = 1;
                })
            } 
            else {
                // do nothing if [Next] is not enabled (use aria-disabled for better accessibility)
                if (this.insuranceInfo == 'yes') {

                    await this.getSaveWipData().then((result) =>{
                        console.log(result)
                    });
                    
                    // await this.getRegistrationRenewalFee().then((result) =>{
                    //     console.log(result)
                    //     this.$emit('getStep', 3);
                    // });
                }
                else if (this.insuranceInfo == 'no') {
                    this.insuranceShowErrorMessage = true;
                }
                else{
                    this.insuranceError = true;
                }
            }
        },

        async goToTxnCart() {
            // await this.getRemoveTransaction().then(() => {
            await this.getCancelTransaction().then(() => {
                this.$emit('getStep' , 4);
                this.$store.state.guestLogin.step = 4;
            });
        },

        async getGoToProfile() {
            // await this.getRemoveTransaction().then( () => {
            await this.getCancelTransaction().then( () => {
                this.$router.push({name: 'Profile'});
            }) 
        },

        getShowModalActive() {
            this.showModalActive = false;
            document.getElementById("mainContent").setAttribute("tabindex", "1");
            document.getElementById("mainContent").focus();

            document.getElementById("mainContent").removeAttribute("tabindex");
            document.getElementById("mainContent").scrollTop = 0;
        },

        showRenewRegModal(val) {
            this.activeModal = false;
            if(val == 'Yes') {
                // this.getRemoveTransaction().then( () => {
                this.getCancelTransaction().then( () => {
                    this.$store.state.guestLogin.step = 4;
                }) 
            }
        },
    },

    mounted() {
        window.scroll(0,0);

        document.getElementById("mainContent").focus();
    }
    
}
</script>

<style lang="scss" scoped>
    .app-alert-error {
        display: block;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 18px;
        line-height: 28px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .app-input-group {
        display: flex;
        margin-top: 0.5rem;
        gap: 2rem;
        .input-radio {
            min-width: 100px;
            input[type="radio"] {
            margin: 0.5em 0;
            }
        }
        label {
            margin-top: 0.65em;
        }
    }

    .app-modal-basic {
        overflow-y: auto;
        height: 300px;
    }

    .app-error-message {
        color: var(--ri-red);
        @extend %font-sans-regular;
        line-height: 1.35em;
        margin: unset;
        padding: 0.5em 0;
        &.--checker {
            margin-left: 1.5em;
        }
    }  
    .insuranceShowError >>> p {
        font-size: 1rem;
        line-height: 1.5em;
        padding-top: .5em;
        padding-bottom: .5em;
    }
    .resend-code{
        background-color: white;
        color: var(--ri-blue);

        &:hover{
            background-color: var(--ri-lighter-blue);
            color: var(--ri-darker-blue);
        }
    } 
</style>
